import { Box } from '@ltvco/refresh-lib/theme';

import { FilterData } from '../types';
import { filterKeyToLabel } from '../utils/constants';

function capitalizeFirst(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function FilterSummaryMessage({ filters }: { filters: FilterData }) {
  if (!filters || Object.keys(filters).length === 0) {
    return null;
  }
  return (
    <Box sx={{ marginY: 0.5 }}>
      <ul style={{ margin: 0, paddingLeft: 24 }}>
        {Object.entries(filters).map(([key, value]) => (
          <li key={key} style={{ fontSize: 13.5, margin: 2 }}>
            <b>{filterKeyToLabel[key] || capitalizeFirst(key)}</b>: {value}
          </li>
        ))}
      </ul>
    </Box>
  );
}
